<div tid="entity_header" class="entity-header-container">
    <div tid="entity_name" class="item-name h1-light " title="{{getDisplayName()}}">
        <span *ngIf="config.entity && !config.entity.isPublic" class="item-lock">
            <smart-icon name="locked" class="light"></smart-icon>
        </span>
        <span tid="entity_name"
            [ngClass]="{'item-name-value-embedded':config.isSideSheet,'item-name-value':!config.isSideSheet}">
            {{getDisplayName()}}
        </span>
        <div tid="entity_type" *ngIf="config.entity && config.entity.type" class="item-type">
            {{config.entity.type.name}}
        </div>
        <div tid="entity_edit" #tooltip class="edit-entity" *ngIf="canEdit" kendoTooltip position="bottom"
            tooltipClass="tooltip-adjust-right">
            <smart-icon name="pencil" (click)="editEntity()" class="light" title="Edit"></smart-icon>
        </div>
        <div class="link-entity-detail" #tooltip *ngIf="config.embedMode && config.entity" (click)="goToEntityDetail()"
            kendoTooltip position="bottom" tooltipClass="tooltip-adjust-right">
            <a class="link" (click)="diableLink($event)" [href]="'/tamaleweb/entity/'+config.entity.id">
                <smart-icon name="sign-out" class="light" title="Go to detail page"></smart-icon>
            </a>
        </div>
        <div tid="operation_save" class="operation-box" *ngIf="isPPCUser&&!config.embedMode&&!isIPAD">
            <button tam-button tamType="primary" tamSize="normal" (click)="onSaveClick()">Publish</button>
        </div>
    </div>
</div>